import React from 'react';
import { Button, ButtonProps, CircularProgress, Tooltip } from '@mui/material';
import { AutoAwesome as AiIcon } from '@mui/icons-material';

interface Props extends Omit<ButtonProps, 'color'> {
  /** Ein Satz, was beim Klick passiert — und was nicht: gespeichert wird nur, was jemand übernimmt. */
  hinweis: string;
  /** Das Modell arbeitet gerade — der Knopf zeigt es und lässt sich nicht noch einmal drücken. */
  laeuft?: boolean;
}

/**
 * Der eine Knopf für alles, hinter dem ein Modell steht. Orange, sonst
 * nirgends in der Oberfläche; mit Text, der sagt, was er tut; und mit einem
 * Satz beim Verweilen, der sagt, was passiert und was nicht. Ein Knopf, der
 * aussieht wie jeder andere, wird gedrückt wie jeder andere — dieser nicht.
 */
export const KiKnopf: React.FC<Props> = ({ hinweis, laeuft = false, startIcon, disabled, variant = 'outlined', children, sx, ...rest }) => (
  <Tooltip title={hinweis} describeChild arrow enterDelay={300}>
    {/* Das span nimmt den Tooltip auch dann an, wenn der Knopf gesperrt ist. */}
    <span style={{ display: 'inline-flex' }}>
      <Button
        color="ki"
        variant={variant}
        startIcon={laeuft ? <CircularProgress size={16} color="inherit" /> : (startIcon ?? <AiIcon />)}
        disabled={disabled || laeuft}
        sx={sx}
        {...rest}
      >
        {children}
      </Button>
    </span>
  </Tooltip>
);
